import React, { useEffect } from 'react';

import { useFormikContext } from 'formik';

export default function FormikListener({ onChange, onDirtyChange }) {
  const formikContext = useFormikContext();

  useEffect(() => {
    if (onChange) {
      onChange(formikContext.values);
    }
  }, [formikContext.values]);

  useEffect(() => {
    if (onDirtyChange) {
      onDirtyChange(formikContext.dirty);
    }
  }, [formikContext.dirty]);

  return null;
}
